
















import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  components: {}
})
export default class System extends Vue {
  @Prop(Object) private item: object;
  // 跳转
  handleNavgater(url) {
    window.location = url;
  }
}
